import { VMTip, VMVraag } from '../vm_models';
export class VMContentId {
  contentId: string
}

export class VMModule {
  id: string;
  key: string; 
  naam: string;
  maximumScore: string;
  vragen: VMVraag[];
  status: string;
  tips: VMTip[];
}

export class VMModulesContentResponse {
  module: VMModule;
}

export class VMModulesResponse {
  modules: VMModule[];
}

export class VMFinishedModuleResponse {
  veiligheidsmeter: {
    id: string
  }
}

export class vmResultResponse {
  module: {
    id: string,
    badge: string,
    opOrde: VMContentId[],
    nietOpOrde: VMContentId[],
    nietGeselecteerd: VMContentId[]
  }
}